export default {
    name: 'AiCatalogListSkeleton',
    props: {
        showRightElement: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
